import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_POP_UP, ROUTER_ORDER_SHEET_SELLER} from '@web/core/routes'
import {openPopup} from '@web/helpers/browser'
import {orderEntryInfoSelector} from '@web/slices/common/slice'

import {NavigationActionStoreState, ThunkApi} from '../interfaces'

const POPUP_KEY = 'CLOSE_EASY_MOBILE_PAY'

/**
 * 간편결제 탈퇴 페이지로 이동
 */
const navigateToEasyMobileClose = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/easyMobileClose',
    async (_, {getState}) => {
        const state = getState()
        const url = getPopupUrl(state)

        return openPopup({
            key: POPUP_KEY,
            url,
            title: '간편결제 해지',
            size: {
                width: 500,
                height: 640,
            },
        })
    },
)

function getPopupUrl(state: NavigationActionStoreState) {
    const {isCheckout, isSellerGroup} = orderEntryInfoSelector(state)

    switch (true) {
        case isSellerGroup:
            return ROUTER_ORDER_SHEET_SELLER.POP_UP.CANCEL_MOBILE_PIN
        case isCheckout:
        default:
            return ROUTER_ORDER_POP_UP.PIN_PAY_PASS_CLOSE
    }
}
export default navigateToEasyMobileClose
